import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureModalService } from './feature-modal.service';
import { FeatureModalComponent } from './feature-modal.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [FeatureModalComponent],
    exports: [FeatureModalComponent],
    imports: [CommonModule, TranslateModule],
    providers: [FeatureModalService]
})
export class FeatureModalModule {}
